import type { IWeek } from '../interfaces/IWeek';
import type { IGame } from '../interfaces/IGame';
import type { ITeam } from '../interfaces/ITeam';
import type { ISeries } from '../interfaces/ISeries';
import { Enumerable } from '../linq';

export abstract class WeekBase implements IWeek {
  Division: KnockoutObservable<string>;
  games: KnockoutObservableArray<KnockoutObservable<IGame>>;
  GamesComputed: KnockoutComputed<KnockoutObservable<IGame>[]>;
  RankComputed: KnockoutComputed<KnockoutObservable<ITeam>[]>;
  TeamsOnBye: KnockoutComputed<KnockoutObservable<ITeam>[]>;
  TeamsInWeek: KnockoutObservableArray<number>;
  Series: KnockoutObservableArray<ISeries>;

  constructor(Division: string) {
    const self = this;

    self.TeamsInWeek = ko.observableArray([]);
    self.Series = ko.observableArray([]);
    self.Division = ko.observable<string>(Division);
    self.games = ko.observableArray<KnockoutObservable<IGame>>();

    self.GamesComputed = ko.computed(() => self.createGamesComputed());

    // Track teams as games are added
    self.games.subscribe(
      (newVal: KnockoutArrayChange<KnockoutObservable<IGame>>[]) => {
        const game: IGame = ko.unwrap(newVal[0].value);
        const home = ko.unwrap(game.home);
        const away = ko.unwrap(game.away);
        self.TeamsInWeek.push(home.TeamID);
        self.TeamsInWeek.push(away.TeamID);
      },
      null,
      'arrayChange'
    );
  }

  /**
   * Override in sport-specific subclasses for custom sort logic.
   * Base: simple ascending sort by SortOrder, then by home team abbreviation.
   */
  protected createGamesComputed(): KnockoutObservable<IGame>[] {
    const self = this;
    return Enumerable.From(self.games())
      .OrderBy((p: KnockoutObservable<IGame> | IGame) => {
        if (typeof p === 'function') {
          return (p as KnockoutObservable<IGame>)().SortOrder();
        }
        return (p as IGame).SortOrder();
      })
      .ThenBy((p: KnockoutObservable<IGame> | IGame) => {
        if (typeof p === 'function') {
          return (p as KnockoutObservable<IGame>)().home().TeamAbbreviation;
        }
        return (p as IGame).home().TeamAbbreviation;
      })
      .ToArray() as KnockoutObservable<IGame>[];
  }
}
